<template>
  <Tooltip :delay="delay" :disabled="disabled || !hasContent" :placement="placement">
    <template #trigger>
      <Focusable>
        <slot name="trigger"><Icon name="HelpCircle" :size="size" /> </slot>
      </Focusable>
    </template>
    <span class="ui-helper-tooltip">
      <Text v-if="header" size="text-xs" weight="semibold">{{ header }}</Text>
      <Text v-if="content" color="color-gray-light-300" size="text-xs" weight="medium">
        {{ content }}
      </Text>
      <slot />
    </span>
  </Tooltip>
</template>
<script setup lang="ts">
  import type { Placement } from '@popperjs/core'
  import { computed, useSlots } from 'vue'

  import { Focusable } from '../Focusable'
  import { Icon } from '../Icon'
  import { Text } from '../Text'

  import Tooltip from './Tooltip.vue'

  const props = withDefaults(
    defineProps<{
      content?: string
      delay?: number
      disabled?: boolean
      header?: string
      placement?: Placement
      size?: number
    }>(),
    { delay: 300, placement: 'top', size: 16 },
  )
  const slots = useSlots()
  const hasContent = computed(() => Boolean(props.content || props.header || slots.default))
</script>
<style scoped>
  .ui-helper-tooltip {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
</style>
